export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/character_modeling.d435320.svg";